<template>
  <div :class="$style.page">
    <Header :showCenter="false" />

    <div :class="$style.content">
      <div :class="$style.content_left">
        <img
          :class="$style.banner"
          src="@assets/image/login_bg.png"
          alt="banner"
        />
      </div>

      <div :class="$style.content_right">
        <Loading :loading="loading" icon="el-icon-loading" text="登录中...">
          <div :class="$style.form">
            <Row :class="$style.logo">
              <img src="@assets/image/logo.png" alt="logo" />
            </Row>

            <!-- step -->
            <Row :class="$style.step_wrap">
              <div
                :class="[$style.step, step > index && $style.active]"
                v-for="(item, index) of stepList"
                :key="index"
              >
                <div :class="$style.line"></div>
                <div :class="$style.name">{{ item }}</div>
              </div>
            </Row>

            <!-- step1 -->
            <template v-if="step === 1">
              <Row>
                <el-input
                  placeholder="手机号码/邮箱"
                  v-model.trim="account"
                  maxlength="50"
                >
                  <img
                    slot="prefix"
                    src="@assets/image/user.png"
                    alt="people"
                  />
                </el-input>
              </Row>

              <Row>
                <el-input
                  v-model.trim="inputCode"
                  placeholder="验证码"
                  maxlength="4"
                />
                <div :class="$style.captcha">
                  <PictureCode :code="pictureCode" />
                  <i class="el-icon-refresh" @click="refreshCode"></i>
                </div>
              </Row>

              <Row>
                <Button type="primary" :loading="loading" @click="clickStep1">
                  下一步
                </Button>
              </Row>
            </template>

            <!-- step2 -->
            <template v-if="step === 2">
              <Row>
                <p :class="$style.desc">为了你的帐号安全，请完成身份验证</p>
              </Row>
              <Row> {{ getLookValue() }} </Row>
              <Row>
                <el-input
                  v-model.trim="code"
                  placeholder="验证码"
                  maxlength="6"
                />
                <CaptchaButton
                  ref="captchaButton"
                  :sendByCode="true"
                  :code="verifyCode"
                />
              </Row>
              <Row>
                <Button type="primary" :loading="loading" @click="clickStep2">
                  下一步
                </Button>
              </Row>
            </template>

            <!-- step3 -->
            <template v-if="step === 3">
              <Row> {{ getLookValue() }} </Row>
              <Row>
                <el-input
                  v-model.trim="password"
                  placeholder="请输入新密码"
                  type="password"
                  maxlength="16"
                >
                  <img
                    slot="prefix"
                    src="@assets/image/lock.png"
                    alt="people"
                  />
                </el-input>
              </Row>

              <Row>
                <el-input
                  v-model.trim="confirmPassword"
                  type="password"
                  placeholder="请确认新密码"
                  maxlength="16"
                >
                  <img
                    slot="prefix"
                    src="@assets/image/lock.png"
                    alt="people"
                  />
                </el-input>
              </Row>
              <Row>
                <Button type="primary" :loading="loading" @click="submit">
                  确认
                </Button>
              </Row>
            </template>

            <template v-if="step === 4">
              <Row :class="$style.success_row">
                <img src="@assets/image/success.png" alt="" />
                <p>恭喜你，密码重置成功！</p>
              </Row>

              <Row>
                <Button type="primary" :loading="loading" @click="toLogin">
                  立即登录
                </Button>
              </Row>
            </template>
          </div>
        </Loading>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@components/Header.vue";
import Footer from "@components/Footer.vue";
import PictureCode from "@components/PictureCode.vue";
import CaptchaButton from "@components/CaptchaButton.vue";

import {
  getPublicKey,
  verifyForgetPwd,
  verifyForgetPwdSmsCode,
  updateForgetPwd,
} from "@server";
import { validPhone, validEmail, encryptPwd } from "@utils";
import { makeCode } from "@utils/makeCode.js";

export default {
  name: "Login",
  components: {
    Header,
    Footer,
    PictureCode,
    CaptchaButton,
  },
  data() {
    return {
      loading: false,
      stepList: ["输入验证码", "校验信息", "输入验证码", "完成"],
      step: 1,

      account: "", // 账户
      inputCode: "",
      pictureCode: makeCode(), // 展示的身份图形验证码

      phone: "",
      email: "",
      verifyCode: "",
      code: "",

      password: "",
      confirmPassword: "",
    };
  },
  methods: {
    async getPublicKey() {
      if (!this.$storage.getPublicKey()) {
        let res = await getPublicKey();
        if (res.code == 200) {
          this.$storage.setPublicKey(res.data);
        }
      }
    },

    refreshCode() {
      this.pictureCode = makeCode();
    },

    getLookValue() {
      let arr = []
      if (this.phone && this.phone.length > 0) {
        arr.push('手机号：' + this.phone)
      }
      if (this.email && this.email.length > 0) {
        arr.push('邮箱：' + this.email)
      }
      return arr.join(" / ")
    },

    // step1
    checkStep1() {
      if (!validPhone(this.account) && !validEmail(this.account)) {
        this.$message({
          message: `请输入${this.account ? "正确的" : ""}手机号码或邮箱`,
          type: "warning",
        });
        return false;
      }

      if (this.inputCode.toUpperCase() !== this.pictureCode.toUpperCase()) {
        this.$message({ message: "请输入正确的图形验证码", type: "warning" });
        return false;
      }

      return true;
    },

    async clickStep1() {
      if (!this.checkStep1()) return;

      const res = await verifyForgetPwd({
        account: this.account,
      });

      if (res.code === 200) {
        this.phone = res.data.phone;
        this.email = res.data.email;
        this.verifyCode = res.data.msgCode;
        this.step = 2;
        this.$nextTick(() => {
          this.$refs.captchaButton.handleClick();
        });
      }
    },

    // step2
    async clickStep2() {
      if (this.code.length < 6) {
        this.$message({
          message: `请输入${this.code && "正确的"}验证码`,
          type: "warning",
        });
        return false;
      }

      this.loading = true;
      const res = await verifyForgetPwdSmsCode({
        code: this.code,
        verifyCode: this.verifyCode,
      });
      const { code, result, data } = res;

      if (code === 200 && result) {
        this.verifyCode = data;
        this.step = 3;
      }
      this.loading = false;
    },

    // submit
    checkSubmit() {
      if (this.password.length < 8) {
        this.$message({ message: "请输入 8-16 位密码", type: "warning" });
        return false;
      }
      if (this.confirmPassword.length < 8) {
        this.$message({ message: "请输入 8-16 位确认密码", type: "warning" });
        return false;
      }
      if (this.password !== this.confirmPassword) {
        this.$message({ message: "两次密码输入不一致!", type: "warning" });
        return false;
      }

      return true;
    },

    async submit() {
      if (!this.checkSubmit()) return;

      this.loading = true;
      const data = {
        newPwd: encryptPwd(this.password),
        newConfirmPwd: encryptPwd(this.confirmPassword),
        msgCode: this.verifyCode,
      };
      const res = await updateForgetPwd(data);

      if (res.code === 200) {
        this.step = 4;
      }
      this.loading = false;
    },

    // to login
    toLogin() {
      this.$router.push("/login");
    },
  },
  created() {
    this.getPublicKey();
  },
};
</script>

<style lang="scss" module scoped>
.page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
  font-size: rem(14);
  color: #333;

  :global {
    .gl-row {
      margin-bottom: rem(30);
      justify-content: space-between;
    }

    ::v-deep .el-input {
      &.el-input--prefix {
        .el-input__inner {
          padding-left: rem(56);
        }
      }

      .el-input__prefix {
        left: 0;
        width: rem(56);
        @include flex();

        img {
          width: max(rem(16), 12px);
          object-fit: cover;
        }
      }
    }

    .gl-button {
      width: 100%;
      margin: 0;

      &.gl-button--primary {
        margin-top: rem(10);
      }
    }

    ::v-deep .el-checkbox {
      margin-right: rem(60);

      .el-checkbox__label {
        padding-left: rem(15);
      }
    }
  }

  .content {
    flex: 1;
    margin: rem(60) auto;
    padding-top: rem(80);
    display: flex;
    justify-content: center;

    .content_left {
      width: rem(820);
      height: rem(680);
      margin-right: rem(60);

      .banner {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .content_right {
      box-sizing: border-box;
      width: rem(490);
      min-width: 245px;
      height: rem(680);
      padding: rem(24) rem(60);
      background: #fff;
      box-shadow: 0px 5px 18px 0px rgba(0, 0, 0, 0.06);
      border: $border-1;
      border-radius: 4px;
    }
  }

  .form {
    height: 100%;

    .logo {
      height: rem(120);
      @include flex();

      img {
        height: rem(54);
        object-fit: cover;
      }
    }

    .captcha {
      @include flex();
      margin-left: rem(10);

      :global {
        .el-icon-refresh {
          margin-left: rem(10);
          font-size: 20px;
          color: #999;
          font-weight: bold;
          cursor: pointer;
          &:hover {
            color: $theme-color;
          }
        }
      }
    }

    .desc {
      font-size: rem(14);
      color: #999;
      line-height: rem(32);
    }
  }

  .step_wrap {
    justify-content: space-between;
    flex-wrap: nowrap;
    margin-bottom: rem(40);

    .step {
      flex: 1;

      .line {
        width: 100%;
        height: 1px;
        background: #e8e8e8;
        position: relative;

        &::before {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          width: 10px;
          height: 10px;
          transform: translate(-50%, -50%);
          background: #555555;
          border-radius: 50%;
        }
      }

      .name {
        margin-top: rem(32);
        font-size: rem(14);
        font-weight: bold;
        color: #333;
        text-align: center;
      }

      &.active {
        .line::before {
          background: $theme-color;
        }

        .name {
          color: $theme-color;
        }
      }
    }
  }

  .success_row {
    flex-direction: column;

    > img {
      width: rem(60);
      margin-top: rem(30);
      object-fit: cover;
    }

    > p {
      margin-top: rem(30);
      margin-bottom: rem(30);
    }
  }
}
</style>
